/* Industry CRUD + merchant industry assignment.
 * Mirrors the pattern in services/merchant.js — class with static methods
 * and Promise-wrapped Request.send calls that always resolve (never throw)
 * with { success, data | errors } payloads. */

import Request from './request';

export default class IndustryService {
  static async getList(includeDisabled = true) {
    return new Promise((resolve) => {
      Request.send({
        method: 'GET',
        path: 'admin/industries',
        query: { includeDisabled }
      })
        .then((result = {}) => {
          if (result.success && Array.isArray(result.data)) {
            return resolve({ success: true, data: result.data });
          }
          return resolve(result);
        })
        .catch((error) => {
          console.error('Industry list error:', error);
          return resolve({
            success: false,
            errors: [{ message: error.message || 'Failed to fetch industries' }]
          });
        });
    });
  }

  static async create(data = {}) {
    const payload = {
      code: (data.code || '').trim().toLowerCase(),
      name: (data.name || '').trim(),
      defaultAvgTicketSizeCents: Number(data.defaultAvgTicketSizeCents)
    };
    return new Promise((resolve) => {
      Request.send({ method: 'POST', path: 'admin/industries', data: payload })
        .then((result = {}) => {
          if (result.success && result.data) {
            return resolve({ success: true, data: result.data });
          }
          return resolve(result);
        })
        .catch((error) => {
          console.error('Industry create error:', error);
          return resolve({
            success: false,
            errors: [{ message: error.message || 'Failed to create industry' }]
          });
        });
    });
  }

  static async update(code, data = {}) {
    const payload = {};
    if (data.name !== undefined) payload.name = String(data.name).trim();
    if (data.defaultAvgTicketSizeCents !== undefined) {
      payload.defaultAvgTicketSizeCents = Number(data.defaultAvgTicketSizeCents);
    }
    if (data.isActive !== undefined) payload.isActive = Boolean(data.isActive);

    return new Promise((resolve) => {
      Request.send({ method: 'PATCH', path: `admin/industries/${code}`, data: payload })
        .then((result = {}) => {
          if (result.success && result.data) {
            return resolve({ success: true, data: result.data });
          }
          return resolve(result);
        })
        .catch((error) => {
          console.error('Industry update error:', error);
          return resolve({
            success: false,
            errors: [{ message: error.message || 'Failed to update industry' }]
          });
        });
    });
  }

  static async disable(code) {
    return new Promise((resolve) => {
      Request.send({ method: 'DELETE', path: `admin/industries/${code}` })
        .then((result = {}) => {
          if (result.success && result.data) {
            return resolve({ success: true, data: result.data });
          }
          return resolve(result);
        })
        .catch((error) => {
          console.error('Industry disable error:', error);
          return resolve({
            success: false,
            errors: [{ message: error.message || 'Failed to disable industry' }]
          });
        });
    });
  }

  /** Assign or unassign a merchant industry. Pass null to clear. */
  static async assignMerchantIndustry(merchantId, industryCode) {
    return new Promise((resolve) => {
      Request.send({
        method: 'PATCH',
        path: `admin/merchants/${merchantId}/industry`,
        data: { industryCode: industryCode || null }
      })
        .then((result = {}) => {
          if (result.success && result.data) {
            return resolve({ success: true, data: result.data });
          }
          return resolve(result);
        })
        .catch((error) => {
          console.error('Assign merchant industry error:', error);
          return resolve({
            success: false,
            errors: [{ message: error.message || 'Failed to assign industry' }]
          });
        });
    });
  }
}
